export default __webpack_public_path__ + "static/media/visa-icon.d243b588.svg";